<template>
  <notifications class="c-notification" group="global" :position="positionNotification" :duration="6000" :width="560" animation-name="s-pop" :speed="375" style="max-width: 100%">
    <template v-slot:body="{ item, close }">
      <aside class="c-notification_item" :class="`c-notification_item--${item.type}`">
        <span  class="c-notification_icon" @click="close"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" v-bind:svg-inline="''" v-bind:class="'c-notification_icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.72 7.28L7.28 8.72 14.563 16l-7.28 7.28 1.437 1.44L16 17.437l7.28 7.28 1.44-1.437L17.437 16l7.28-7.28-1.437-1.44L16 14.563z"/></svg></span>
        <h3 class="c-notification_title" v-if="item.title">{{ item.title}}</h3>
        <p class="c-notification_text">{{ item.text }}</p>
      </aside>
    </template>
  </notifications>
</template>

<script>

export default {

  computed: {
    positionNotification() {
      return window.innerWidth < 600 ? 'bottom' : 'center bottom'
    }
  }
}
</script>

<style lang="scss">
@import "~css/_references";

.c-notification {
  padding: $v-gap-xxs;
  box-sizing: border-box;

  .notification-wrapper {
    padding: $v-gap-xxs;
    box-sizing: border-box;
  }

  &_item {
    position: relative;
    top: 0;
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: $v-gap-xs;
    color: $v-colorRed;
    border-radius: $v-boxRadius;
    background-color: $v-colorRed;
    box-shadow: $v-boxShadow;
    line-height: 1.5;

    &--interactive {
      transition: all $v-duration-enter $v-easing-swift-in;
      cursor: pointer;

      &:hover {
        top: -2px;
        box-shadow: $v-boxShadow-far;
      }

      &:focus,
      &:active {
        top: 0;
        box-shadow: $v-boxShadow-close;
      }
    }

    &--warn {
      background-color: $v-colorOrange;
    }

    &--error {
      background-color: $v-colorRed;
    }

    &--success {
      background-color: $v-colorGreen;
    }

    &--fillWarn {
      background: $v-colorOrange;
      color: $v-colorWhite;
    }

    &--fillError {
      background: $v-colorRed;
      color: $v-colorWhite;
    }

    &--fillSuccess {
      background: $v-colorGreen;
      color: $v-colorWhite;
    }
  }

  &_title {
    box-sizing: border-box;
    font-weight: 600;
    font-size: $v-fontSize-subheader;
    box-sizing: border-box;
    color: $v-colorWhite;

    &:not(:empty) { padding: $v-gap-xxs 30px $v-gap-xxs $v-gap-xxs; }
  }

  &_icon {
    position: absolute;
    width: 25px;
    height: 25px;
    top: 9px;
    right: 9px;
    cursor: pointer;
    fill: $v-colorWhite;
  }

  &_text {
    margin: 0;
    box-sizing: border-box;
    font-size: $v-fontSize-body;
    word-wrap: break-word;
    box-sizing: border-box;
    color: $v-colorWhite;

    &:not(:empty) { padding: $v-gap-xxs 30px $v-gap-xxs $v-gap-xxs; }
  }
}
</style>